import * as Geographic from "./Geographic/index.js";
/** CoStar.Api.FusionSearch.Migrated.Criteria.ResultReductionType */
export var ResultReductionType;
(function (ResultReductionType) {
    ResultReductionType[ResultReductionType["Overpost"] = 0] = "Overpost";
    ResultReductionType[ResultReductionType["ServerSort"] = 1] = "ServerSort";
})(ResultReductionType || (ResultReductionType = {}));
import { EnergyCertification } from "../../../../../CoStar/Api/FusionSearch/Criteria/index.js";
/** CoStar.Api.FusionSearch.Migrated.Criteria.EnergyCertification */
export { EnergyCertification };
/** CoStar.Api.FusionSearch.Migrated.Criteria.SaleCompExclusion */
export var SaleCompExclusion;
(function (SaleCompExclusion) {
    SaleCompExclusion[SaleCompExclusion["None"] = 0] = "None";
    SaleCompExclusion[SaleCompExclusion["Condos"] = 1] = "Condos";
    SaleCompExclusion[SaleCompExclusion["BulkPortfolios"] = 2] = "BulkPortfolios";
    SaleCompExclusion[SaleCompExclusion["NonArmsLength"] = 3] = "NonArmsLength";
    SaleCompExclusion[SaleCompExclusion["PublicRecords"] = 4] = "PublicRecords";
    SaleCompExclusion[SaleCompExclusion["MultiPropertyPortfolios"] = 5] = "MultiPropertyPortfolios";
    SaleCompExclusion[SaleCompExclusion["NonCondos"] = 6] = "NonCondos";
    SaleCompExclusion[SaleCompExclusion["NonBulkPortfolios"] = 7] = "NonBulkPortfolios";
    SaleCompExclusion[SaleCompExclusion["NonMultiPropertyPortfolios"] = 8] = "NonMultiPropertyPortfolios";
})(SaleCompExclusion || (SaleCompExclusion = {}));
import { Tenancy } from "../../../../../CoStar/Api/FusionSearch/Criteria/index.js";
/** CoStar.Api.FusionSearch.Migrated.Criteria.Tenancy */
export { Tenancy };
/** CoStar.Api.FusionSearch.Migrated.Criteria.ForSaleExclusion */
export var ForSaleExclusion;
(function (ForSaleExclusion) {
    ForSaleExclusion[ForSaleExclusion["None"] = 0] = "None";
    ForSaleExclusion[ForSaleExclusion["Condos"] = 1] = "Condos";
    ForSaleExclusion[ForSaleExclusion["BulkPortfolios"] = 2] = "BulkPortfolios";
    ForSaleExclusion[ForSaleExclusion["MultiPropertyPortfolios"] = 3] = "MultiPropertyPortfolios";
    ForSaleExclusion[ForSaleExclusion["NonCondos"] = 4] = "NonCondos";
})(ForSaleExclusion || (ForSaleExclusion = {}));
/** CoStar.Api.FusionSearch.Migrated.Criteria.ForLeaseExclusion */
export var ForLeaseExclusion;
(function (ForLeaseExclusion) {
    ForLeaseExclusion[ForLeaseExclusion["None"] = 0] = "None";
    ForLeaseExclusion[ForLeaseExclusion["DivisibleSpaces"] = 1] = "DivisibleSpaces";
    ForLeaseExclusion[ForLeaseExclusion["NotFullFloor"] = 2] = "NotFullFloor";
    ForLeaseExclusion[ForLeaseExclusion["PendingLeases"] = 3] = "PendingLeases";
})(ForLeaseExclusion || (ForLeaseExclusion = {}));
/** CoStar.Api.FusionSearch.Migrated.Criteria.SpaceTypeCategory */
export var SpaceTypeCategory;
(function (SpaceTypeCategory) {
    SpaceTypeCategory[SpaceTypeCategory["None"] = 0] = "None";
    SpaceTypeCategory[SpaceTypeCategory["Direct"] = 1] = "Direct";
    SpaceTypeCategory[SpaceTypeCategory["Sublet"] = 2] = "Sublet";
})(SpaceTypeCategory || (SpaceTypeCategory = {}));
/** CoStar.Api.FusionSearch.Migrated.Criteria.SpaceType */
export var SpaceType;
(function (SpaceType) {
    SpaceType[SpaceType["None"] = 0] = "None";
    SpaceType[SpaceType["Relet"] = 1] = "Relet";
    SpaceType[SpaceType["New"] = 2] = "New";
    SpaceType[SpaceType["Sublet"] = 3] = "Sublet";
})(SpaceType || (SpaceType = {}));
export { Geographic };
